import { createContext } from 'react';

const emailTemplatesContext = createContext();

export default emailTemplatesContext;
